/* eslint-disable no-unused-vars */

import router from '../../router'
import axios from 'axios'
import { post, put, get, remove } from '@/api/api'

export const actions = {
  async fetchUsers ({ commit }) {
    const { data } = await get('/user')
    commit('addUser', data)
  },
  async fetchUsersPage({commit}, params = {}) {
    const { page = 0, size = 10, sort = '', email = '', nom = '', prenoms = '', telephone = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort, 
      ...(email && { email }),
      ...(nom && { nom }),
      ...(prenoms && { prenoms }),
      ...(telephone && { telephone }),
    }).toString();

    let { data } = await get(`/user?${queryParams}`);
    commit("addUsers", data)
    return data;
  },
  async signUp ({ commit }, payload) {
    console.log('je suis dans sigup')
    console.log(payload)
    const data = await post('/user/signUp/admin', payload)
    console.log(data)
  },
  async signin ({ commit }, payload) {
    console.log('je suis dans sigin')
    console.log(payload)
    const data = await axios
      .post('/user/signIn', {
        //telephone: payload.telephone,
        email: payload.email,
        password: payload.password,
        //code: payload.code
      })
  },
  selectProduct ({ commit }, user) {
    commit('setUser', user)
  },
  updatePermission ({ commit }, user) {
    return post(`/user/edit/user/${user.id}`, user)
      .then(({ data }) => {})
  },
  createOrUpdateUser ({ dispatch }, user) {
    if (user.id !== undefined) {
      return dispatch('updatePermission', user)
    } else {
      return dispatch('signUp', user)
    }
  },
  async journalisation({commit}, params = {}) {
    const { page = 0, size = 10, sort = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort
    }).toString();

    let { data } = await get(`/canal/logs/all?${queryParams}`);
    return data;
  },
  forgetPassword ({ commit }, payload) {
    return post(`/user/reset`, payload)
      .then(({ data }) => {})
  },
  updatePassword ({ commit }, payload) {
    return post(`/user/change/${payload.id}`, payload)
      .then(({ data }) => {})
  },
  updateProfilUser ({ commit }, payload) {
    return post(`/user/change/user`, payload)
      .then(({ data }) => {})
  },
}
